import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'category',
  pure: false
})
export class CategoryPipe implements PipeTransform {
  transform(items: any[], cat: number): any {
    if (!items || !cat) {
      return items;
    }
    return items.filter(item => Number(item.category) === Number(cat));
  }
}


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contract-list/category.pipe.ts